<div class="login-page-wrapper">
    <div class="container">
      <div class="row">
        <div class="col-md-5 d-flex flex-column justify-content-center">
            <div class="text-white">
                <!-- <h3>Welcome to</h3> -->
                <h1>Few things about you</h1>
                <!-- <p>
                  Lorem ipsum dolor sit, amet consectetur adipisicing elit. Dolorum
                  eligendi exercitationem sint.
                </p> -->
              </div>
        </div>
        <div class="col-md-7">
          <div
            class="
              login-form
              d-flex
              flex-column
              justify-content-center
            "
          >
            <!-- <h2 class="mb-4">Admin login</h2> -->
            <img class="mb-2" src="../assets/images/logo.png" alt="" srcset="" />
            <form [formGroup]="signInForm">
              <div class="row g-2 mb-3 justify-content-between phone-field">
                
                <mat-form-field appearance="outline" class="col-12">
                  <mat-label>Name</mat-label>
                  <input
                    matInput
                    type="tel"
                    formControlName="name"
                    required
                  />
                  
                </mat-form-field>
                <mat-form-field class="w-100" appearance="outline" class="col-12" (click)="picker1.open()">
                    <mat-label>Date of birth</mat-label>
                    <input matInput [matDatepicker]="picker1" formControlName="dob" readonly>
                    <!-- <mat-hint>MM/DD/YYYY</mat-hint> -->
                    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                    <mat-datepicker #picker1 disabled="false"></mat-datepicker>
                  </mat-form-field>
                  <div class="radio_group">
                    <label>Gender: </label>
                    <mat-radio-group formControlName="gender">
                      <mat-radio-button value="Male">Male</mat-radio-button>
                      <mat-radio-button value="Female">Female</mat-radio-button>
                      <mat-radio-button value="Others">Others</mat-radio-button>
                    </mat-radio-group>
                  </div>
                  <mat-form-field appearance="outline">
                    <mat-label>Address</mat-label>
                    <input
                    formControlName="address"
                      matInput
                      (input)="updateSearchResults()"
                      [matAutocomplete]="auto"
                    />
                    <!-- <mat-icon matSuffix class="material-icons-outlined"
                      >person_pin_circle</mat-icon
                    > -->
                    <mat-autocomplete #auto="matAutocomplete">
                      <mat-option
                        *ngFor="let item of autocompleteItems"
                        (click)="selectSearchResult(item)"
                      >
                        {{ item.description }}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
              </div>
              <!-- <div class="mb-3" *ngIf="otpReceived">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Enter OTP</mat-label>
                  <input
                    matInput
                    type="text"
                    maxlength="6"
                    formControlName="otp"
                    required
                  />
                  <mat-error>Invalid OTP</mat-error>
                </mat-form-field>
              </div> -->
  
              <!-- <mat-form-field appearance="outline" class="w-100" color="accent">
                  <mat-label>Password</mat-label>
                  <input matInput placeholder="Enter password" [type]="passwordHide ? 'password' : 'text'" formControlName="password">
                  <button mat-icon-button matSuffix (click)="passwordHide = !passwordHide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="passwordHide">
                      <mat-icon class="material-icons-round">{{passwordHide ? 'visibility_off' : 'visibility'}}</mat-icon>
                  </button>
                  <mat-hint>Minimum 6 characters</mat-hint>
                  <mat-error>Enter password</mat-error>
                </mat-form-field> -->
              <button
                mat-flat-button
                color="accent"
                class="w-100"
                [disabled]="signInForm.invalid || sendingOtpStatus"
                (click)="onSignIn()"
                #submitButton
              >
                Save and Go
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  